import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import GarageIcon from '@mui/icons-material/Garage';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import WavesIcon from '@mui/icons-material/Waves';
import OpacityIcon from '@mui/icons-material/Opacity';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import HotelIcon from '@mui/icons-material/Hotel';
import StraightenIcon from '@mui/icons-material/Straighten';
import KitchenIcon from '@mui/icons-material/Kitchen';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import HotTubIcon from '@mui/icons-material/HotTub';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import StairsIcon from '@mui/icons-material/Stairs';
import SecurityIcon from '@mui/icons-material/Security';

const sectionss = [
    {
        title: 'Exterior Home Features',
        icon: <HomeWorkIcon fontSize="small" />,
        items: ['Roof: Asphalt', 'Patio / Porch: Deck', 'Foundation: Concrete Perimeter']
    },
    {
        title: 'Parking & Garage',
        icon: <GarageIcon fontSize="small" />,
        items: [
            'Number of Garage Spaces: 2',
            'Number of Covered Spaces: 2',
            'Has a Garage',
            'Has an Attached Garage',
            'Has Open Parking',
            'Parking Spaces: 2',
            'Parking: Asphalt, Garage Door Opener, On Site, Garage Owned, Attached, Garage'
        ]
    },
    {
        title: 'Frontage',
        icon: <WavesIcon fontSize="small" />,
        items: ['Not on Waterfront']
    },
    {
        title: 'Water & Sewer',
        icon: <OpacityIcon fontSize="small" />,
        items: ['Sewer: Public Sewer']
    }
];

const sections = [
    {
        title: 'Interior Details',
        icon: <HomeWorkIcon fontSize="small" />,
        items: [
            'Basement: Partially Finished, Full',
            'Number of Rooms: 8',
            'Types of Rooms: Master Bedroom, Bedroom 2, Bedroom 3, Bedroom 4, Dining Room, Eating Area, Family Room, Foyer, Kitchen, Laundry, Living Room, Loft'
        ]
    },
    {
        title: 'Beds & Baths',
        icon: <HotelIcon fontSize="small" />,
        items: [
            'Number of Bedrooms: 2',
            'Number of Bathrooms: 2',
            'Number of Bathrooms (half): 1',
            'Number of Bathrooms (full): 1'
        ]
    },
    {
        title: 'Dimensions and Layout',
        icon: <StraightenIcon fontSize="small" />,
        items: ['Living Area: 1575 Square Feet']
    },
    {
        title: 'Appliances & Utilities',
        icon: <KitchenIcon fontSize="small" />,
        items: [
            'Appliances: Range, Microwave, Dishwasher, Refrigerator, Washer, Dryer, Humidifier, Gas Water Heater',
            'Dishwasher',
            'Dryer',
            'Laundry: Main Level, Gas Dryer Hookup, In Unit',
            'Microwave',
            'Refrigerator',
            'Washer'
        ]
    },
    {
        title: 'Heating & Cooling',
        icon: <AcUnitIcon fontSize="small" />,
        items: [
            'Heating: Natural Gas',
            'Has Heating',
            'Heating Fuel: Natural Gas',
            'Has Cooling',
            'Air Conditioning: Central Air'
        ]
    },
    {
        title: 'Fireplace & Spa',
        icon: <HotTubIcon fontSize="small" />,
        items: ['No Spa']
    },
    {
        title: 'Gas & Electric',
        icon: <FlashOnIcon fontSize="small" />,
        items: ['Electric: 200+ Amp Service']
    },
    {
        title: 'Windows, Doors, Floors & Walls',
        icon: <MeetingRoomIcon fontSize="small" />,
        items: [
            'Window: Drapes',
            'Door: Panel Door(s)',
            'Flooring: Hardwood, Carpet'
        ]
    },
    {
        title: 'Levels, Entrance, & Accessibility',
        icon: <StairsIcon fontSize="small" />,
        items: [
            'Number of Stories: 2',
            'Accessibility: No Disability Access',
            'Floors: Hardwood, Carpet'
        ]
    },
    {
        title: 'Security',
        icon: <SecurityIcon fontSize="small" />,
        items: ['Security: Carbon Monoxide Detector(s)']
    }
];

function PropertyInformation() {
    return (

        <>
            <Card className='shadow-sm' style={{ borderRadius: '6px' }}>
                <Card.Header className="bg-light d-flex align-items-center">
                    <strong>Interior Features</strong>
                </Card.Header>
                <Card.Body className="p-0">
                    {sections.map((section, idx) => (
                        <div key={idx} className="p-3 border-top">
                            <div className="d-flex align-items-center mb-2">
                                {section.icon}
                                <span className="ms-2 fw-semibold">{section.title}</span>
                            </div>
                            <Row>
                                {section.items.map((item, i) => (
                                    <Col lg={4} key={i} className="mb-2">
                                        • {item}
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))}
                </Card.Body>
            </Card>


            <Card className='mt-3 shadow-sm' style={{ borderRadius: '6px' }}>
                <Card.Header className="bg-light d-flex align-items-center">
                    <strong>Exterior Features</strong>
                </Card.Header>
                <Card.Body className="p-0">
                    {sectionss.map((section, idx) => (
                        <div key={idx} className="p-3 border-top">
                            <div className="d-flex align-items-center mb-2">
                                {section.icon}
                                <span className="ms-2 fw-semibold">{section.title}</span>
                            </div>
                            <Row>
                                {section.items.map((item, i) => (
                                    <Col lg={4} key={i} className="mb-2">
                                        • {item}
                                    </Col>
                                ))}
                            </Row>
                        </div>
                    ))}
                </Card.Body>
            </Card>

        </>
    );
}

export default PropertyInformation;